/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import { ThunkDispatch } from "redux-thunk";
import {
  loadCustomFieldsAction,
  loadCustomFieldsSuccessAction,
  saveCustomFieldAction,
  saveCustomFieldFailureAction,
  deleteCustomFieldAction,
  deleteCustomFieldFailureAction,
  loadCustomFieldsFailureAction,
  saveCustomFieldSuccessAction,
  deleteCustomFieldSuccessAction
} from "./action-creators";
import * as APICustomField from "api/custom-field";

export type SuccessFn = (dispatch: ThunkDispatch<any, any, any>) => void;
export type FailureFn = (e: Error, dispatch: ThunkDispatch<any, any, any>) => void;

export const loadCustomFields = (
  options: { "field-type": APICustomField.AllowedFieldTypes },
  successFn?: SuccessFn,
  failureFn?: FailureFn
) => async (dispatch: ThunkDispatch<any, any, any>) => {
  dispatch(loadCustomFieldsAction());

  try {
    const customFields = await APICustomField.getCustomFields(options);
    dispatch(loadCustomFieldsSuccessAction(customFields));
    if (successFn) {
      successFn(dispatch);
    }
  } catch (e) {
    dispatch(loadCustomFieldsFailureAction(e));
    if (failureFn) {
      failureFn(e, dispatch);
    }
  }
};

export const saveCustomField = (
  customField: APICustomField.UnsavedCustomField,
  successFn?: SuccessFn,
  failureFn?: FailureFn
) => async (dispatch: ThunkDispatch<any, any, any>) => {
  dispatch(saveCustomFieldAction());

  try {
    await APICustomField.createCustomField(customField);
    dispatch(saveCustomFieldSuccessAction());
    if (successFn) {
      successFn(dispatch);
    }
  } catch (e) {
    dispatch(saveCustomFieldFailureAction(e));
    if (failureFn) {
      failureFn(e, dispatch);
    }
  }
};

export const deleteCustomField = (
  customField: APICustomField.CustomField,
  successFn?: SuccessFn,
  failureFn?: FailureFn
) => async (dispatch: ThunkDispatch<any, any, any>) => {
  dispatch(deleteCustomFieldAction(customField));

  try {
    await APICustomField.deleteCustomField(customField.id);
    dispatch(deleteCustomFieldSuccessAction());
    if (successFn) {
      successFn(dispatch);
    }
  } catch (e) {
    dispatch(deleteCustomFieldFailureAction(e));
    if (failureFn) {
      failureFn(e, dispatch);
    }
  }
};
